import { render } from "./Datepicker.vue?vue&type=template&id=c2638d3c&scoped=true"
import script from "./Datepicker.vue?vue&type=script&lang=js"
export * from "./Datepicker.vue?vue&type=script&lang=js"

import "./Datepicker.vue?vue&type=style&index=0&id=c2638d3c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c2638d3c"

export default script